import React, { useCallback, useContext, useEffect, useState } from 'react';
import ModalItem from '../../common/ModalItem/ModalItem';
import Container from '@material-ui/core/Container';
import { useTranslation } from 'react-i18next';
import { changeErrorPopupState } from '../../../store/uiSlice';
import { connect } from 'react-redux';
import './user-payment.scss';
import YellowButton from '../../common/YellowButton';
import * as paymentActions from '../../../store/paymentSlice';
import * as userActions from '../../../store/userSlice';
import { Hidden } from '@material-ui/core';
import CustomBackdrop from '../../common/CustomBackdrop';
import IsMobileContext from '../../../common/IsMobileContext';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { completedRoutes, paymentPinLength, paymentStates, routes } from '../../../common/constants';
import Execute from './Execute';
import ReactPinInput from 'react-pin-input';
import { Link } from 'react-router-dom';
import ExplainPopup from './Explain/ExplainPopup';
import { lazyWithDelay } from '../../../common/lazyWithDelay';

const UserPaymentExplain = lazyWithDelay(import('../UserPayment/Explain/ExplainCarousel'));

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      <Route path={completedRoutes.userPaymentExecute}>
        <Execute />
      </Route>
      <Route path={completedRoutes.userPaymentExplain}>
        <React.Suspense fallback={<CustomBackdrop open />}>
          <UserPaymentExplain />
        </React.Suspense>
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

let pinElement = null;

function UserPayment(props) {
  const { t } = useTranslation();
  const isMobileDesign = useContext(IsMobileContext);
  const history = useHistory();
  const [code, setCode] = useState('');

  let isFirstShow = localStorage.getItem('isFirstShow');

  const {
    changeErrorPopupState, getUserBalance, isLogged,
    getPaymentByCode, fetchingState,
  } = props;

  const handleSubmit = useCallback((e) => {
    e && e.preventDefault();
    Promise.all([getUserBalance(), getPaymentByCode(code)])
      .then(([balance, { amount, state }]) => {
        if (+amount > +balance) {
          changeErrorPopupState({ type: 'paymentCodeBalance', isOpen: true });
        } else if (state === paymentStates.created) {
          history.push(completedRoutes.userPaymentExecute);
        } else {
          changeErrorPopupState({ type: 'paymentExpired', isOpen: true });
        }
      })
      .catch((error) => {
        if (error.status === 401) {
          history.replace(completedRoutes.signUpModalItem, { currentUrl: completedRoutes.userPayment });
        } else {
          changeErrorPopupState({ error, type: 'paymentCode', isOpen: true });
        }
      })
  }, [changeErrorPopupState, history, code, getUserBalance, getPaymentByCode]);

  useEffect(() => {
    if (code.length === paymentPinLength) {
      handleSubmit();
      pinElement && pinElement.clear();
      setCode('');
    }
  }, [code, handleSubmit]);
  useEffect(() => {
    if (isMobileDesign && isLogged) {
      history.push(`${routes.userPayment}/${routes.paymentExplainPopup}`);
    }
    // eslint-disable-next-line
  }, []);

  if (isFirstShow === null) {
    // isFirstShow = true;
    localStorage.setItem('isFirstShow', 'false');
  }
  // if (isFirstShow !== 'false' && isMobileDesign) {
  //   return <Redirect to={completedRoutes.userPaymentExplain} />
  // }

  if (!isLogged) {
    return <Redirect to={completedRoutes.signUpModalItem} />;
  }

  const handleGoBack = () => {
    history.replace(completedRoutes.userTasks);
  };

  const isLoading = fetchingState === 'requesting';

  const content = (
    <Container className="payoff-container">
      <div className="content">
        <h2>{t('userPayment.title')}</h2>
        <p>{t('userPayment.p1')}</p>
        <form onSubmit={handleSubmit}>
          <ReactPinInput type='numeric'
                         length={paymentPinLength}
                         onChange={setCode}
                         ref={p => (pinElement = p)}
                         name="code"
          />
          <p>{t('userPayment.p2')}</p>
          {isMobileDesign &&
          <p>
            <Link to={completedRoutes.userPaymentExplain}>
              {t('userPayment.wtf')}
            </Link>
          </p>
          }
          <div className="btn">
            <YellowButton type="submit"
                          hidden={false}
                          title={t('common.next')}
                          disabled={code.length !== paymentPinLength}
            />
          </div>
        </form>
      </div>
    </Container>
  );

  return (
    <ModalItem handleClose={handleGoBack}>
      <>
        <Hidden mdUp>
          {content}
          <Switch>
            <Route path={completedRoutes.userPaymentExplainPopup}>
              <ExplainPopup />
            </Route>
          </Switch>
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
        <CustomBackdrop open={isLoading} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = (state) => ({
  fetchingState: state.payments.fetchingState,
  isLogged: state.auth.isLogged,
});

const actionCreators = {
  changeErrorPopupState: changeErrorPopupState,
  getPaymentByCode: paymentActions.getPaymentByCode,
  getUserBalance: userActions.getUserBalance,
};

export default connect(mapStateToProps, actionCreators)(UserPayment);
